import {
  addDays,
  addHours,
  endOfDay as dateFnsEndOfDay,
  format,
  isAfter,
  parseISO,
  subYears
} from 'date-fns';

/*
 * Documentação com todos os formatos(tokens): https://date-fns.org/v1.30.1/docs/format
 */
const HOUR_MINUTE = 'HH:mm';
const YEAR_MONTH_DAY = 'yyyy-MM-dd';
const DAY_MONTH_YEAR = 'dd/MM/yyyy';

/**
 * @param quantidade quantidade de anos que será subtraído
 * @param data (Opcional) data inicial que será subtraída
 */
export const subtrairAno = (
  quantidade: number,
  data = new Date(Date.now())
) => {
  const dataSubtraida = subYears(data, quantidade);
  return format(dataSubtraida, YEAR_MONTH_DAY);
};

export const getFirstDayOfYear = () => format(new Date(), 'yyyy-01-01');

export const getDataAtual = () => format(Date.now(), YEAR_MONTH_DAY);

export const getDateAndCurrentTime = () => {
  const [date, hour] = format(
    Date.now(),
    `${YEAR_MONTH_DAY} ${HOUR_MINUTE}`
  ).split(' ');

  return `${date}T${hour}`;
};

export const getCurrentYear = () => new Date(Date.now()).getFullYear();

export const getYearFromDate = date => new Date(date).getUTCFullYear();

export const formatarData = (data: string) =>
  format(parseISO(data), DAY_MONTH_YEAR);

export const dateSortDesc = (date1: string, date2: string) => {
  const date1Date = new Date(date1);
  const date2Date = new Date(date2);

  if (date1Date > date2Date) return -1;
  if (date1Date < date2Date) return 1;
  return 0;
};

export const getMenorUltimoDiaDosMeses = (meses: number[] = []) => {
  const anoAtual = new Date(Date.now()).getFullYear();
  let menorDia = 31;
  meses.forEach(m => {
    const menorDiaMes = new Date(anoAtual, m, 0).getDate();
    if (menorDiaMes < menorDia) {
      menorDia = menorDiaMes;
    }
  });

  return menorDia;
};

export const addDaysToDate = (date, days): string => {
  return format(addDays(parseISO(date), days), YEAR_MONTH_DAY);
};

export const endOfDay = (date: string): Date => {
  return dateFnsEndOfDay(parseISO(date));
};

export const getStartOfMonth = (): string => {
  const now = new Date(Date.now());
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}-01`;
};

export const getEndOfMonth = (): string => {
  const now = new Date(Date.now());
  const year = now.getFullYear();
  const month = now.getMonth();
  const lastDay = new Date(year, month + 1, 0).getDate();
  const monthStr = String(month + 1).padStart(2, '0');
  return `${year}-${monthStr}-${String(lastDay).padStart(2, '0')}`;
};

export const extractTimePartsFromDate = (
  date: Date = new Date()
): { hour: string; minute: string; second: string } => {
  const [hour, minute, second] = [
    String(date.getHours()).padStart(2, '0'),
    String(date.getMinutes()).padStart(2, '0'),
    String(date.getSeconds()).padStart(2, '0')
  ];

  return {
    hour,
    minute,
    second
  };
};

export const isDateMoreThanHoursAhead = (date: string, hours: number) => {
  return isAfter(new Date(date), addHours(new Date(), hours));
};

export const formatarDataToISOString = (date: Date) => {
  return date?.toISOString().split('T')[0];
};
